import { client } from '../client';
import { ICase } from './types/ICase';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

export interface IAssignCACase {
  care_advisor_id: number;
  enforce_assignment?: boolean;
}

export const assignCareAdvisor = async (case_id: number, payload: IAssignCACase, userRole?: string): Promise<ICase> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const { data } = await client.patch(`${prefix}/cases/${case_id}/assign_ca`, payload);

  return data;
};
